"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const addresses_1 = require("../addresses");
exports.routes = Object.keys(addresses_1.addresses).reduce((routesObj, chainId) => {
    const routeIds = addresses_1.addresses[chainId].routeIds;
    const bridges = Object.keys(routeIds)
        .map((bridgeName) => {
        return Object.assign({ bridgeName }, routeIds[bridgeName]);
    })
        .filter((x) => x.isMiddleware === false);
    const middlewares = Object.keys(routeIds)
        .map((middlewareName) => {
        return Object.assign({ middlewareName }, routeIds[middlewareName]);
    })
        .filter((x) => x.isMiddleware === true);
    routesObj[chainId] = {
        bridgeNames: bridges.reduce((bridgeIds, bridge) => {
            bridgeIds[bridge.routeId] = bridge.bridgeName;
            return bridgeIds;
        }, {}),
        bridgeIds: bridges.reduce((bridgeNames, bridge) => {
            bridgeNames[bridge.bridgeName] = bridge.routeId;
            return bridgeNames;
        }, {}),
        middlewareNames: middlewares.reduce((middlewareIds, middleware) => {
            middlewareIds[middleware.routeId] = middleware.middlewareName;
            return middlewareIds;
        }, {}),
        middlewareIds: middlewares.reduce((middlewareNames, middleware) => {
            middlewareNames[middleware.middlewareName] = middleware.routeId;
            return middlewareNames;
        }, {})
    };
    return routesObj;
}, {});
